import script from "./SearchLandingPageTestOpportunity.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchLandingPageTestOpportunity.vue?vue&type=script&setup=true&lang=js"

import "./SearchLandingPageTestOpportunity.vue?vue&type=style&index=0&id=a14abb58&lang=css"

const __exports__ = script;

export default __exports__